import { useEffect, useState } from "react";

const SearchableOptions = ({
  options,
  optionLabel,
  optionValue,
  value,
  onChange,
}) => {
  const [optionsLoc, setOptionsLoc] = useState([]);
  const [searchText, setSearchText] = useState("");
  const isSelected = (o) => value.find((r) => r?.[optionValue] === o);

  useEffect(() => {
    setOptionsLoc(
      searchText
        ? options.filter((r) =>
            r?.[optionLabel]?.toLowerCase().includes(searchText.toLowerCase())
          )
        : options
    );
  }, [options, searchText, optionLabel]);

  return (
    <div style={{ padding: "10px 16px" }}>
      <input
        className="form-control mb-2"
        placeholder="Search"
        onChange={({ target }) => setSearchText(target.value)}
      />
      <div className="options-overlay">
        {optionsLoc.map((opt) => (
          <div
            role="button"
            className={`${
              isSelected(opt[optionValue])
                ? `option-overlay-item-selected`
                : `option-overlay-item `
            }`}
            onClick={() => onChange(opt)}
          >
            {opt[optionLabel]}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchableOptions;
